import React from 'react';
import _ from 'lodash';
import PropTypes from "prop-types";

const propTypes = {
	id: PropTypes.number.isRequired,
	end_date: PropTypes.string.isRequired,
	start_date: PropTypes.string.isRequired,
	offers: PropTypes.string.isRequired,
	objective: PropTypes.array.isRequired,
	name: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	description: PropTypes.string,
	level: PropTypes.string.isRequired,
	place: PropTypes.object
}

const DirectoryServiceItem = ({id, name, start_date, end_date, offers, objective, type, description, level, place}) => {
		return <div className="cdm-directory--detail" key={`dir-entry-${id}`}>
			<h5 className="title is-5">{name}</h5>
			<p>
				<span>Institución</span>
				{place.name}
			</p>
			<p>
				<span>Tipo</span>
				{type}
			</p>
			<p>
				<span>Vigencia</span>
				{start_date} a {end_date}
			</p>
			<p>
				<span>Población objetivo</span>
				{_.map(objective, (item, i) => {
					return [item.name, <br key={`break-${i}`} />];
				})}
			</p>

			<div className="content desc" dangerouslySetInnerHTML={{__html:description}} />

			<div className="content offers" dangerouslySetInnerHTML={{__html:offers}} />
		</div>
}

DirectoryServiceItem.propTypes = propTypes;

export default DirectoryServiceItem;



// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/directory/directory-service-item.jsx